import { format } from "date-fns";

/**
 * Parses a date-only `YYYY-MM-DD` string as a local-timezone Date. Using the
 * Date constructor on the raw string would parse as UTC midnight and shift
 * the calendar day for viewers west of UTC.
 */
export function parseDateOnly(value: string): Date {
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day);
}

/**
 * Formats a Date as the date-only `YYYY-MM-DD` string the API expects.
 */
export function formatDateOnly(date: Date): string {
  return format(date, "yyyy-MM-dd");
}
